import React from 'react';
import { useAnalytics } from '@Shared/useAnalytics';
import {
  MyCarvanaButton,
  MyCarvanaSubText,
  MyCarvanaWrapper,
} from './MyCarvana.styles';

const MyCarvana = () => {
  const { trackEvent, trackEventAndGo } = useAnalytics();
  const myCarvanaClicked = ev => {
    trackEvent('my_carvana_account_link_tap');
    trackEventAndGo(ev, 'clicked my carvana account link', {}, '/my-carvana');
  };

  return (
    <MyCarvanaWrapper>
      <MyCarvanaButton
        onClick={myCarvanaClicked}
        href="/my-carvana"
        target="_self"
      >
        <div>
            My Cars
          <MyCarvanaSubText>
              Manage my ride and make payments
          </MyCarvanaSubText>
        </div>
      </MyCarvanaButton>
    </MyCarvanaWrapper>
  );
};

export default MyCarvana;
